var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#221F20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00016 6C2.44788 6 2.00016 5.55228 2.00016 5C2.00016 4.44772 2.44788 4 3.00016 4C3.55245 4 4.00016 4.44772 4.00016 5C4.00016 5.55228 3.55245 6 3.00016 6ZM3 20.0001C2.44772 20.0001 2 19.5524 2 19.0001C2 18.4479 2.44772 18.0001 3 18.0001C3.55228 18.0001 4 18.4479 4 19.0001C4 19.5524 3.55228 20.0001 3 20.0001ZM3 13.0001C2.44772 13.0001 2 12.5524 2 12.0001C2 11.4478 2.44772 11.0001 3 11.0001C3.55228 11.0001 4 11.4478 4 12.0001C4 12.5524 3.55228 13.0001 3 13.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6V4H22V6H6ZM6 20.0001V18.0001H22V20.0001H6ZM6 11.0001V13.0001H22V11.0001H6Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.e127c3ae014a34299c7addbc41388a0f.svg";
export { ForwardRef as ReactComponent };